"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AgentEditSaveButton = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const Button_1 = require("../../../Button");
const AgentEditSaveButton = (props) => {
    const { disabled, hidden, handleOnSubmit } = props;
    if (hidden)
        return null;
    return (react_1.default.createElement(Button_1.Button, { icon: 'save', text: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Agent/Edit:Save', defaultMessage: 'Save' }), type: 'submit', onClick: handleOnSubmit, disabled: disabled }));
};
exports.AgentEditSaveButton = AgentEditSaveButton;
//# sourceMappingURL=save.js.map